<div class="modal fade group-class-save " id="appModal" #appModal tabindex="-1" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="modal-header p-0 align-items-center">
                    <span class="pl-4 register-attendees" translate>GroupClassDetails.AddParticipantHeader</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="container mt-2 mb-4 pl-4 text-bayclub-blue">
                    <bcu-local-spinner [size]="25" [visible]="!isLoaded" *ngIf="!isLoaded"></bcu-local-spinner>
                    <form [formGroup]="form" *ngIf="isLoaded">
                        <div class="row form-group">
                            <div class="col">
                                <label
                                    for="participant">{{'GroupClassDetails.AddParticipantNameLabel' | translate}}</label>
                                <app-member-search formControlName='participant' [isValid]="isMemberSearchValid">
                                </app-member-search>
                            </div>
                        </div>
                        <div class="row form-group" *ngIf="requiresResources">
                            <div class="col">
                                <label for="resourceId" translate>GroupClassDetails.AddResourceNameLabel</label>
                                <bcu-drop-down-cf2 id="resourceId" formControlName="resource" [options]="resources"
                                    valueKey="id" displayKey="label" textAlign="left">
                                </bcu-drop-down-cf2>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer p-0 align-items-center justify-content-end" *ngIf="isLoaded">
                    <button class="btn bc-button mr-1 my-3" (click)="onClose()" translate>Cancel</button>
                    <button class="btn btn-success ml-1 my-3 mr-3" (click)="onSave()" translate>Confirm</button>
                </div>
            </div>
        </div>
    </div>
</div>
